import React from 'react';

import { ProductCollection } from '../product-collection';
import { ProductThumbnail } from '../../..';
import { ProductCarousel } from '../../../product-carousel';

import { ProductDiscoveryCarouselProps } from './product-discovery-carousel-type';

import styles from './product-discovery-carousel-component.module.css';

export const ProductDiscoveryCarousel: React.FC<ProductDiscoveryCarouselProps> = (
    props: ProductDiscoveryCarouselProps,
) => {
    const { collections, favorites, id, variants } = props;
    if (props && collections && collections.length > 0) {
        const trimmedCollection = collections.filter(item => {
            const isDifferentProduct =
                item.id !== id.toString() && (variants || []).find(v => v.id === item.variantId) === undefined;
            return isDifferentProduct;
        });
        if (trimmedCollection.length > 0) {
            return (
                <div className={styles.container}>
                    <div className={styles.title}>Dans la même collection</div>

                    <div className={styles.carouselContainer}>
                        <ProductCollection products={trimmedCollection} />
                    </div>
                </div>
            );
        }
    }
    if (props && favorites && favorites.length > 0) {
        const trimmedFavorites = favorites.filter(item => {
            const isDifferentProduct =
                item.id !== id.toString() && (variants || []).find(v => v.id === item.variantId) === undefined;
            return isDifferentProduct;
        });
        if (trimmedFavorites.length > 0) {
            return (
                <div className={styles.container}>
                    <div className={styles.title}>Découvrez aussi</div>

                    <ProductCarousel>
                        {trimmedFavorites.map((item, key) => {
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <React.Fragment key={key}>
                                    <ProductThumbnail product={item} />
                                </React.Fragment>
                            );
                        })}
                    </ProductCarousel>
                </div>
            );
        }
    }
    return <React.Fragment></React.Fragment>;
};
